export interface Bonus {
  id: string
  title: string
  value: string
  subtitle: string
  paragraphs: string[]
  benefit: string
}

export const bonuses: Bonus[] = [
  {
    id: '01',
    title: 'Golf Student Assessment, Progress & Lesson Planning Toolkit',
    value: '12',
    subtitle: 'Professional Tools to Evaluate Players, Track Development and Organize Every Session',
    paragraphs: [
      'Structured resources for initial student assessments, skill observations, lesson objectives, progress tracking, instructor notes, short-term priorities and future session planning. Identify strengths, detect areas that need improvement and create a more logical progression from one lesson to the next.',
      'Supports better communication with students by making goals, improvements and next steps easier to explain. Designed for private students, group programs and academy environments — turning isolated lessons into an organized development process.',
    ],
    benefit: 'Open it, follow the structure, and your lessons become a real development system.',
  },
  {
    id: '02',
    title: 'Private Lessons, Group Clinics & Academy Adaptation System',
    value: '12',
    subtitle: 'Adapt the Same Golf Content to Different Formats, Group Sizes and Teaching Environments',
    paragraphs: [
      'Shows you exactly how to adapt golf lessons for private sessions, small groups, clinics, junior programs and academy-based instruction. Explains how to adjust lesson structure, practice time, feedback delivery, student rotation and activity difficulty based on the number of players and the teaching environment.',
      'Learn how to keep every student involved, reduce waiting time and organize stations, partner activities and group challenges more effectively. Includes guidance for adapting lessons when students have different experience levels, physical abilities or learning speeds.',
    ],
    benefit: 'One system. Every format. No rebuilding from scratch.',
  },
  {
    id: '03',
    title: '30 Emergency, Indoor & Limited-Space Golf Lessons',
    value: '10',
    subtitle: 'Ready-to-Use Sessions for Unexpected Situations, Bad Weather and Restricted Practice Areas',
    paragraphs: [
      '30 complete lesson options for days when the original plan cannot be used because of bad weather, unavailable facilities, limited equipment or restricted practice space. Topics include grip, setup, posture, alignment, putting mechanics, swing positions, visualization, decision-making, course strategy, rules, routines and technical review.',
      'Each session is designed to help you continue teaching without wasting the scheduled lesson or improvising at the last minute. A dependable backup system that protects lesson quality, maintains student engagement and keeps the learning process moving forward even when conditions change unexpectedly.',
    ],
    benefit: 'Open it, choose the session, and your lesson starts right.',
  },
]
